//GENERAL DASHBOARD

if($("#dashboard_page").length){
    $.extend( $.fn.dataTable.defaults, {
        language: {
            "processing": '<div class="loader-dash" style="margin-top: 0;"><div style="top: 50%;position: relative;"><div class="cssload-speeding-wheel custom-margin"></div></div></div>'
        },

    });
    var colors = {'advertiser': "#00C851", 'campaign': "#ab8ce4", 'order': "#33b5e5", 'invoice': "#ff4444", 'invoices': "#00C851",'orders': '#13dafe', 'profits': "#6164c1"}
    $(function() {
        $('.chart1').easyPieChart({
            size: 100,
            lineWidth: 7,
            animate: { duration: 1000, enabled: true },
            barColor: '#13dafe'
        });
    });
    $('#easy-pie-chart11').css({
        width : $('#easy-pie-chart11 > canvas').attr('width') + 'px',
        height : $('#easy-pie-chart11 > canvas').attr('height') + 'px'
    });
    $('#easy-pie-chart11 .percent').css({
        "line-height": $('#easy-pie-chart11 > canvas').attr('height') + 'px'
    })
    $('#easy-pie-chart22').css({
        width : $('#easy-pie-chart22 > canvas').attr('width') + 'px',
        height : $('#easy-pie-chart22 > canvas').attr('height') + 'px'
    });
    $('#easy-pie-chart22 .percent').css({
        "line-height": $('#easy-pie-chart22 > canvas').attr('height') + 'px'
    })
    $('#easy-pie-chart33').css({
        width : $('#easy-pie-chart33 > canvas').attr('width') + 'px',
        height : $('#easy-pie-chart33 > canvas').attr('height') + 'px'
    });
    $('#easy-pie-chart33 .percent').css({
        "line-height": $('#easy-pie-chart33 > canvas').attr('height') + 'px'
    })
    $('#easy-pie-chart44').css({
        width : $('#easy-pie-chart44 > canvas').attr('width') + 'px',
        height : $('#easy-pie-chart44 > canvas').attr('height') + 'px'
    });
    $('#easy-pie-chart44 .percent').css({
        "line-height": $('#easy-pie-chart44 > canvas').attr('height') + 'px'
    })
    $('#easy-pie-chart55').css({
        width : $('#easy-pie-chart55 > canvas').attr('width') + 'px',
        height : $('#easy-pie-chart55 > canvas').attr('height') + 'px'
    });
    $('#easy-pie-chart55 .percent').css({
        "line-height": $('#easy-pie-chart55 > canvas').attr('height') + 'px'
    })
    $('#easy-pie-chart66').css({
        width : $('#easy-pie-chart66 > canvas').attr('width') + 'px',
        height : $('#easy-pie-chart66 > canvas').attr('height') + 'px'
    });
    $('#easy-pie-chart66 .percent').css({
        "line-height": $('#easy-pie-chart66 > canvas').attr('height') + 'px'
    })
    $(function() {
        $('.chart2').easyPieChart({
            size: 100,
            lineWidth: 7,
            animate: { duration: 1000, enabled: true },
            barColor: 'orangered'
        });
    });
    $('#easy-pie-chart1').css({
        width : $('#easy-pie-chart1 > canvas').attr('width') + 'px',
        height : $('#easy-pie-chart1 > canvas').attr('height') + 'px'
    });
    $('#easy-pie-chart1 .percent').css({
        "line-height": $('#easy-pie-chart1 > canvas').attr('height') + 'px'
    })
    $('#easy-pie-chart2').css({
        width : $('#easy-pie-chart2 > canvas').attr('width') + 'px',
        height : $('#easy-pie-chart2 > canvas').attr('height') + 'px'
    });
    $('#easy-pie-chart2 .percent').css({
        "line-height": $('#easy-pie-chart2 > canvas').attr('height') + 'px'
    })
    $('#easy-pie-chart3').css({
        width : $('#easy-pie-chart3 > canvas').attr('width') + 'px',
        height : $('#easy-pie-chart3 > canvas').attr('height') + 'px'
    });
    $('#easy-pie-chart3 .percent').css({
        "line-height": $('#easy-pie-chart3 > canvas').attr('height') + 'px'
    })
    $('#easy-pie-chart4').css({
        width : $('#easy-pie-chart4 > canvas').attr('width') + 'px',
        height : $('#easy-pie-chart4 > canvas').attr('height') + 'px'
    });
    $('#easy-pie-chart4 .percent').css({
        "line-height": $('#easy-pie-chart4 > canvas').attr('height') + 'px'
    })
    $('#easy-pie-chart5').css({
        width : $('#easy-pie-chart5 > canvas').attr('width') + 'px',
        height : $('#easy-pie-chart5 > canvas').attr('height') + 'px'
    });
    $('#easy-pie-chart5 .percent').css({
        "line-height": $('#easy-pie-chart5 > canvas').attr('height') + 'px'
    })
    $('#easy-pie-chart6').css({
        width : $('#easy-pie-chart6 > canvas').attr('width') + 'px',
        height : $('#easy-pie-chart6 > canvas').attr('height') + 'px'
    });
    $('#easy-pie-chart6 .percent').css({
        "line-height": $('#easy-pie-chart6 > canvas').attr('height') + 'px'
    })
    $("#sparklinedash").sparkline([0,0,0,0,0,0,0,0,0,0,0,0], {
        type: 'bar',
        height: '30',
        barWidth: 4,
        resize: true,
        barSpacing: 5,
        barColor: '#99d683'

    });
    $('#sparklinedash2').sparkline([0,0,0,0,0,0,0,0,0,0,0,0], {
        type: 'bar',
        height: '30',
        barWidth: '4',
        resize: true,
        barSpacing: '5',
        barColor: '#ab8ce4'
    });
    $('#sparklinedash3').sparkline([0,0,0,0,0,0,0,0,0,0,0,0], {
        type: 'bar',
        height: '30',
        barWidth: '4',
        resize: true,
        barSpacing: '5',
        barColor: '#03a9f3'
    });
    $('#sparklinedash4').sparkline([0,0,0,0,0,0,0,0,0,0,0,0], {
        type: 'bar',
        height: '30',
        barWidth: '4',
        resize: true,
        barSpacing: '5',
        barColor: '#fb9678'
    });
    $('#sparklinedash5').sparkline([0,0,0,0,0,0,0,0,0,0,0,0], {
        type: 'bar',
        height: '30',
        barWidth: '4',
        resize: true,
        barSpacing: '5',
        barColor: '#fb9876'
    });
    $('#sparklinedash6').sparkline([0,0,0,0,0,0,0,0,0,0,0,0], {
        type: 'bar',
        height: '30',
        barWidth: '4',
        resize: true,
        barSpacing: '5',
        barColor: '#fb6789'
    });
    $("#sparkline8").sparkline([0,0,0,0,0,0,0,0,0,0,0,0], {
        type: 'line',
        width: '90%',
        height: '50',
        lineColor: '#99d683',
        fillColor: '#99d683',
        maxSpotColor: '#99d683',
        highlightLineColor: 'rgba(0, 0, 0, 0.2)',
        highlightSpotColor: '#99d683'
    });
    $("#sparkline9").sparkline([0,0,0,0,0,0,0,0,0,0,0,0], {
        type: 'line',
        width: '90%',
        height: '50',
        lineColor: '#13dafe',
        fillColor: '#13dafe',
        minSpotColor:'#13dafe',
        maxSpotColor: '#13dafe',
        highlightLineColor: 'rgba(0, 0, 0, 0.2)',
        highlightSpotColor: '#13dafe'
    });
    $("#sparkline10").sparkline([0,0,0,0,0,0,0,0,0,0,0,0], {
        type: 'line',
        width: '90%',
        height: '50',
        lineColor: '#6164c1',
        fillColor: '#6164c1',
        maxSpotColor: '#6164c1',
        highlightLineColor: 'rgba(0, 0, 0, 0.2)',
        highlightSpotColor: '#6164c1'
    });

    function getDateRange(range){
        var date_range =  moment().subtract(1, 'years').format("YYYY-MM-DD") + "_" + moment().format("YYYY-MM-DD")
        switch (range) {
            case "this_year":
                date_range = moment().startOf('year').format("YYYY-MM-DD") + "_" + moment().endOf('year').format("YYYY-MM-DD")
                break
            case "past_year":
                date_range = moment().subtract(1, 'years').format("YYYY-MM-DD") + "_" + moment().format("YYYY-MM-DD")
                break
            case "quarter":
                date_range = moment().subtract(3, 'months').format("YYYY-MM-DD") + "_" + moment().format("YYYY-MM-DD")
                break
            case "month":
                range = "week"
                bars = [0,0,0,0]
                date_range = moment().subtract(1, 'months').format("YYYY-MM-DD") + "_" + moment().format("YYYY-MM-DD")
                break
            case "week":
                date_range = moment().subtract(7, 'days').format("YYYY-MM-DD") + "_" + moment().format("YYYY-MM-DD")
                break
            case "today":
                date_range = moment().format("YYYY-MM-DD") + "_" + moment().format("YYYY-MM-DD")
                break
        }
        return  date_range;
    }

    function getDateRangeTypeAndBars(start, end){
        var type = "month"
        var bars = [0,0,0,0,0,0,0,0,0,0,0,0]
        if(end.subtract(2, "days") > start){
            if(end.subtract(8, "days") > start){
                if(end.subtract(31, "days") > start){
                    if(end.subtract(92, "days") > start){
                        type = "month"
                        bars = [0,0,0,0,0,0,0,0,0,0,0,0]
                    }else{
                        type = "month"
                        bars = [0, 0, 0]
                    }
                }else{
                    type = "week"
                    bars = [0, 0, 0, 0]
                }
            }else{
                type = "day"
                bars = [0, 0, 0, 0, 0, 0, 0]
            }
        }else{
            type = "day"
            bars = [0]
        }
        return {"type": type, "bars": bars}
    }

    function show_dash_loader(container) {
        $(container).prepend('<div class="loader-dash" style="margin-top: 0;"><div style="top: 50%;position: relative;"><div class="cssload-speeding-wheel custom-margin"></div></div></div>');
    }

    function hide_dash_loader(container) {
        $(container).find('.loader-dash').remove();
    }

    function sparkLine(loader, values, color){
        var box = $('div[data-loader="' + loader + '"]').contents().find(".sparklinedash")
        $(box).sparkline(Object.values(values), {
            type: 'bar',
            height: '30',
            barWidth: 4,
            resize: true,
            barSpacing: 5,
            barColor: color
        });
    }

    function sparkLineBars(loader, values, color){
        var box = $('div[data-loader="' + loader + '"]').contents().find(".sparklinedash")
        $(box).sparkline(Object.values(values), {
            type: 'line',
            width: '90%',
            height: '50',
            lineColor: color,
            fillColor: color,
            maxSpotColor: color,
            highlightLineColor: 'rgba(0, 0, 0, 0.2)',
            highlightSpotColor: color,
            tooltipPrefix: '$',
        });
    }

    function top_line_stats(type, rangeDate, loader, color){
        show_dash_loader('div[data-loader="' + loader + '"]')
        var date_range =  moment().startOf('year').format("YYYY-MM-DD") + "_" + moment().endOf('year').format("YYYY-MM-DD")
        var bars = [0,0,0,0,0,0,0,0,0,0,0,0]
        var range = "month"
        if(typeof rangeDate.chosenLabel !== "undefined") {
            date_range = rangeDate.startDate.format("YYYY-MM-DD") + "_" + rangeDate.endDate.format("YYYY-MM-DD")
            switch (rangeDate.chosenLabel) {
                case "This Year":
                    range = "month"
                    bars = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
                    // date_range = moment().startOf('year').format("YYYY-MM-DD") + "_" + moment().format("YYYY-MM-DD")
                    break
                case "Last Year":
                    range = "month"
                    bars = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
                    // date_range = moment().subtract(1, 'years').format("YYYY-MM-DD") + "_" + moment().format("YYYY-MM-DD")
                    break
                case "This Quarter":
                    range = "month"
                    bars = [0, 0, 0]
                    // date_range = moment().subtract(3, 'months').format("YYYY-MM-DD") + "_" + moment().format("YYYY-MM-DD")
                    break
                case "Last Quarter":
                    range = "month"
                    bars = [0, 0, 0]
                    // date_range = moment().subtract(3, 'months').format("YYYY-MM-DD") + "_" + moment().format("YYYY-MM-DD")
                    break
                case "This Month":
                    range = "week"
                    bars = [0, 0, 0, 0]
                    //date_range = moment().subtract(1, 'months').format("YYYY-MM-DD") + "_" + moment().format("YYYY-MM-DD")
                    break
                case "Last Month":
                    range = "week"
                    bars = [0, 0, 0, 0]
                    //date_range = moment().subtract(1, 'months').format("YYYY-MM-DD") + "_" + moment().format("YYYY-MM-DD")
                    break
                case "This Week":
                    range = "day"
                    bars = [0, 0, 0, 0, 0, 0, 0]
                    //date_range = moment().subtract(7, 'days').format("YYYY-MM-DD") + "_" + moment().format("YYYY-MM-DD")
                    break
                case "Last Week":
                    range = "day"
                    bars = [0, 0, 0, 0, 0, 0, 0]
                    //date_range = moment().subtract(7, 'days').format("YYYY-MM-DD") + "_" + moment().format("YYYY-MM-DD")
                    break
                case "Today":
                    range = "day"
                    bars = [0]
                    //date_range = moment().format("YYYY-MM-DD") + "_" + moment().format("YYYY-MM-DD")
                    break
                case "Custom Range":
                    var data = getDateRangeTypeAndBars(rangeDate.startDate, rangeDate.endDate)
                    range = data["type"]
                    bars = data["bars"]
                    break
            }
        }
        $.ajax({
            url: "/dashboard/top-stats/?type=" + type + "&range=" + date_range + "&group=" + range,
            dataType: 'json',
            success: function (data) {
                for(var i in data.data){bars[i - 1] = data.data[i]}
                sparkLine(loader, bars, color)
                var total = Object.values(data.data).reduce((a, b) => a + b, 0);
                if((total - data.oldTotal[0]) < 0) {
                    $('div[data-loader="' + loader + '"]').contents().find(".compare_arrow").removeClass("ti-arrow-up").addClass("ti-arrow-down")
                }else{
                    $('div[data-loader="' + loader + '"]').contents().find(".compare_arrow").removeClass("ti-arrow-down").addClass("ti-arrow-up")
                }
                $('div[data-loader="' + loader + '"]').contents().find(".counter").html(total)
                hide_dash_loader('div[data-loader="' + loader + '"]')
            },
            error: function (xhr) {
                ajax_error();
                hide_dash_loader('div[data-loader="' + loader + '"]')
            }
        })
    }

    function tables_refresh(type, rangeDate, loader){
        // var date_range = getDateRange(range)
        var date_range =  moment().startOf('year').format("YYYY-MM-DD") + "_" + moment().endOf('year').format("YYYY-MM-DD")
        if(typeof rangeDate.chosenLabel !== "undefined") {
            date_range = rangeDate.startDate.format("YYYY-MM-DD") + "_" + rangeDate.endDate.format("YYYY-MM-DD")
        }
        if(type == "advertiser"){
            refreshAdv = true
            actual_date_range = date_range
            if($('.card[data-loader="table_advertiser"] .nav-item.active a').attr("href") == "#home")
                initializeCampaignsDashTable(date_range)
            else
                initializeAdvertisersTable(false, date_range)
        }
        if(type == "order"){
            initializeOrdersDashTable(date_range)
        }
    }

    function moneyRefresh(type, rangeDate, loader){
        show_dash_loader('div[data-loader="' + loader + '"]')
        // var date_range = getDateRange(range)
        var range = "month"
        var date_range =  moment().startOf('year').format("YYYY-MM-DD") + "_" + moment().endOf('year').format("YYYY-MM-DD")
        if(typeof rangeDate.chosenLabel !== "undefined") {
            date_range = rangeDate.startDate.format("YYYY-MM-DD") + "_" + rangeDate.endDate.format("YYYY-MM-DD")
        }
        var stopLoader = false
        //if(type == "money")
        $.ajax({
            url: "/dashboard/money/data?type=" + type + "&range=" + date_range + "&group=" + range,
            dataType: 'json',
            success: function (data) {
                if(typeof data.data !== "undefined") {
                    var total = Object.values(data.data).reduce((a, b) => a + b, 0)
                    for (var i in data.data) {
                        switch (i) {
                            case "App\\Entities\\LineTelevision":
                                var pie = $(".money_box div.chart.tv")
                                $(pie).data("percent", Math.round((data.data[i] * 100) / total))
                                $(pie).children("span.percent").html(Math.round((data.data[i] * 100) / total))
                                $(pie).data('easyPieChart').update(Math.round((data.data[i] * 100) / total))
                                $(pie).children("h5").html("TV - $" + data.data[i])
                                break
                            case "App\\Entities\\LineRadio":
                                var pie = $(".money_box div.chart.radio")
                                $(pie).data("percent", Math.round((data.data[i] * 100) / total))
                                $(pie).children("span.percent").html(Math.round((data.data[i] * 100) / total))
                                $(pie).data('easyPieChart').update(Math.round((data.data[i] * 100) / total))
                                $(pie).children("h5").html("RADIO - $" + data.data[i])
                                break
                            case "App\\Entities\\LineDigital":
                                var pie = $(".money_box div.chart.digital")
                                $(pie).data("percent", Math.round((data.data[i] * 100) / total))
                                $(pie).children("span.percent").html(Math.round((data.data[i] * 100) / total))
                                $(pie).data('easyPieChart').update(Math.round((data.data[i] * 100) / total))
                                $(pie).children("h5").html("DIGITAL - $" + data.data[i])
                                break
                            case "App\\Entities\\LinePrint":
                                var pie = $(".money_box div.chart.print")
                                $(pie).data("percent", Math.round((data.data[i] * 100) / total))
                                $(pie).children("span.percent").html(Math.round((data.data[i] * 100) / total))
                                $(pie).data('easyPieChart').update(Math.round((data.data[i] * 100) / total))
                                $(pie).children("h5").html("PRINT - $" + data.data[i])
                                break
                            case "App\\Entities\\LineMail":
                                var pie = $(".money_box div.chart.mail")
                                $(pie).data("percent", Math.round((data.data[i] * 100) / total))
                                $(pie).children("span.percent").html(Math.round((data.data[i] * 100) / total))
                                $(pie).data('easyPieChart').update(Math.round((data.data[i] * 100) / total))
                                $(pie).children("h5").html("MAIL - $" + data.data[i])
                                break
                            case "App\\Entities\\LineOOH":
                                var pie = $(".money_box div.chart.ooh")
                                $(pie).data("percent", Math.round((data.data[i] * 100) / total))
                                $(pie).children("span.percent").html(Math.round((data.data[i] * 100) / total))
                                $(pie).data('easyPieChart').update(Math.round((data.data[i] * 100) / total))
                                $(pie).children("h5").html("OOH - $" + data.data[i])
                                break
                        }
                    }
                }
                if(stopLoader)
                    hide_dash_loader('div[data-loader="' + loader + '"]')
                else
                    stopLoader = true
            },
            error: function (xhr) {
                ajax_error();
                hide_dash_loader('div[data-loader="' + loader + '"]')
            }
        })
        //else
        $.ajax({
            url: "/dashboard?range=" + date_range,
            dataType: 'json',
            success: function (data) {
                if(typeof data.mtypes !== "undefined" && typeof data.totalmt !== "undefined" && data.totalmt > 0) {
                    for (var i in data.mtypes) {
                        switch (i) {
                            case "tv":
                                var pie = $(".buy_box div.chart.tv")
                                $(pie).data("percent", Math.round((data.mtypes[i] * 100) / data.totalmt))
                                $(pie).children("span.percent").html(Math.round((data.mtypes[i] * 100) / data.totalmt))
                                $(pie).data('easyPieChart').update(Math.round((data.mtypes[i] * 100) / data.totalmt))
                                break
                            case "radio":
                                var pie = $(".buy_box div.chart.radio")
                                $(pie).data("percent", Math.round((data.mtypes[i] * 100) / data.totalmt))
                                $(pie).children("span.percent").html(Math.round((data.mtypes[i] * 100) / data.totalmt))
                                $(pie).data('easyPieChart').update(Math.round((data.mtypes[i] * 100) / data.totalmt))
                                break
                            case "digital":
                                var pie = $(".buy_box div.chart.digital")
                                $(pie).data("percent", Math.round((data.mtypes[i] * 100) / data.totalmt))
                                $(pie).children("span.percent").html(Math.round((data.mtypes[i] * 100) / data.totalmt))
                                $(pie).data('easyPieChart').update(Math.round((data.mtypes[i] * 100) / data.totalmt))
                                break
                            case "print":
                                var pie = $(".buy_box div.chart.print")
                                $(pie).data("percent", Math.round((data.mtypes[i] * 100) / data.totalmt))
                                $(pie).children("span.percent").html(Math.round((data.mtypes[i] * 100) / data.totalmt))
                                $(pie).data('easyPieChart').update(Math.round((data.mtypes[i] * 100) / data.totalmt))
                                break
                            case "mail":
                                var pie = $(".buy_box div.chart.mail")
                                $(pie).data("percent", Math.round((data.mtypes[i] * 100) / data.totalmt))
                                $(pie).children("span.percent").html(Math.round((data.mtypes[i] * 100) / data.totalmt))
                                $(pie).data('easyPieChart').update(Math.round((data.mtypes[i] * 100) / data.totalmt))
                                break
                            case "ooh":
                                var pie = $(".buy_box div.chart.ooh")
                                $(pie).data("percent", Math.round((data.mtypes[i] * 100) / data.totalmt))
                                $(pie).children("span.percent").html(Math.round((data.mtypes[i] * 100) / data.totalmt))
                                $(pie).data('easyPieChart').update(Math.round((data.mtypes[i] * 100) / data.totalmt))
                                break
                        }
                    }
                }
                if(stopLoader)
                    hide_dash_loader('div[data-loader="' + loader + '"]')
                else
                    stopLoader = true
            },
            error: function (xhr) {
                ajax_error();
                hide_dash_loader('div[data-loader="' + loader + '"]')
            }
        })
    }

    function bottom_line_stats(type, rangeDate, loader, color){
        show_dash_loader('div[data-loader="' + loader + '"]')
        var date_range =  moment().startOf('year').format("YYYY-MM-DD") + "_" + moment().endOf('year').format("YYYY-MM-DD")
        var bars = [0,0,0,0,0,0,0,0,0,0,0,0]
        var range = "month"
        if(typeof rangeDate.chosenLabel !== "undefined") {
            date_range = rangeDate.startDate.format("YYYY-MM-DD") + "_" + rangeDate.endDate.format("YYYY-MM-DD")
            switch (rangeDate.chosenLabel) {
                case "This Year":
                    range = "month"
                    bars = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
                    // date_range = moment().startOf('year').format("YYYY-MM-DD") + "_" + moment().format("YYYY-MM-DD")
                    break
                case "Last Year":
                    range = "month"
                    bars = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
                    // date_range = moment().subtract(1, 'years').format("YYYY-MM-DD") + "_" + moment().format("YYYY-MM-DD")
                    break
                case "This Quarter":
                    range = "month"
                    bars = [0, 0, 0]
                    // date_range = moment().subtract(3, 'months').format("YYYY-MM-DD") + "_" + moment().format("YYYY-MM-DD")
                    break
                case "Last Quarter":
                    range = "month"
                    bars = [0, 0, 0]
                    // date_range = moment().subtract(3, 'months').format("YYYY-MM-DD") + "_" + moment().format("YYYY-MM-DD")
                    break
                case "This Month":
                    range = "week"
                    bars = [0, 0, 0, 0]
                    //date_range = moment().subtract(1, 'months').format("YYYY-MM-DD") + "_" + moment().format("YYYY-MM-DD")
                    break
                case "Last Month":
                    range = "week"
                    bars = [0, 0, 0, 0]
                    //date_range = moment().subtract(1, 'months').format("YYYY-MM-DD") + "_" + moment().format("YYYY-MM-DD")
                    break
                case "This Week":
                    range = "day"
                    bars = [0, 0, 0, 0, 0, 0, 0]
                    //date_range = moment().subtract(7, 'days').format("YYYY-MM-DD") + "_" + moment().format("YYYY-MM-DD")
                    break
                case "Last Week":
                    range = "day"
                    bars = [0, 0, 0, 0, 0, 0, 0]
                    //date_range = moment().subtract(7, 'days').format("YYYY-MM-DD") + "_" + moment().format("YYYY-MM-DD")
                    break
                case "Today":
                    range = "day"
                    bars = [0]
                    //date_range = moment().format("YYYY-MM-DD") + "_" + moment().format("YYYY-MM-DD")
                    break
                case "Custom Range":
                    var data = getDateRangeTypeAndBars(rangeDate.startDate, rangeDate.endDate)
                    range = data["type"]
                    bars = data["bars"]
                    break
            }
        }
        $.ajax({
            url: "/dashboard/invoices/data?type=" + type + "&range=" + date_range + "&group=" + range,
            dataType: 'json',
            success: function (data) {
                for(var i in data.bars){bars[i - 1] = Number(Math.round(data.bars[i] + 'e2') + 'e-2').toFixed(2)}
                console.log("BARS: ", bars)
                sparkLineBars(loader, bars, color)
                if(typeof data.data !== "undefined" && typeof data.data[0] !== "undefined"){
                    for(var i in data.data[0])
                        $('div[data-loader="' + loader + '"] b[data-field="' + i + '"]').html(data.data[0][i])
                }else{
                    $('div[data-loader="' + loader + '"]').contents().find(".stat-item b").html(0)
                }
                $('div[data-loader="' + loader + '"]').contents().find(".counter").html(Object.values(data.data).reduce((a, b) => a + b, 0))
                hide_dash_loader('div[data-loader="' + loader + '"]')
            },
            error: function (xhr) {
                ajax_error();
                hide_dash_loader('div[data-loader="' + loader + '"]')
            }
        })
    }

    $(document).on("change", ".card select.custom-select",function () {
        console.log($(this).val(), $(this).closest("div.card").data("loader"))
        var loader = $(this).closest("div.card").data("loader")
        if(loader.indexOf("table_") !== -1)
            tables_refresh(loader.replace("table_",""), $(this).val(), loader)
        else if(loader.indexOf("money") !== -1){
            moneyRefresh("money", $(this).val(), loader)
            //moneyRefresh("buy", $(this).val(), loader)
        }else if(loader.indexOf("_bottom") !== -1){
            bottom_line_stats(loader.replace("_bottom",""), $(this).val(), loader, colors[loader.replace("_bottom","")])
        }else if(loader.indexOf("_top") !== -1)
            top_line_stats(loader.replace("_top",""), $(this).val(), loader, colors[loader.replace("_top","")])
    })

    if($("#app-orders-dash-table").length){
        function initializeOrdersDashTable(range = "") {
            $('#app-orders-dash-table').DataTable({
                "processing": true,
                "serverSide": true,
                "searching": false,
                "info": false,
                "bFilter": false,
                "bInfo": false,
                "lengthChange": false,
                "scrollY": "300px",
                "scrollCollapse": true,
                ajax: {
                    url: "/dashboard/orders/data?range=" + range,
                    dataSrc: 'data'
                },
                "order": [[ 2, "desc" ]],
                columns: [
                    {data: 'reference_number'},//0
                    {data: 'vendor_name'},//1
                    {data: 'created_at'},
                    {data: 'work'},//2
                    // {data: 'advertiser'},//3
                    // {data: 'campaign'},//3
                    // {data: 'status'},
                ],
                destroy: true,
                "columnDefs": [
                    {
                        "targets": 0,
                        "orderable": false,
                        "createdCell": function (td, cellData, rowData, row, col) {
                            $(td).html(rowData.reference_number);
                        }
                    },
                    {
                        "targets": 1,
                        "orderable": false,
                        "createdCell": function (td, cellData, rowData, row, col) {
                            $(td).html(rowData.vendor_name);
                        }
                    },
                    {
                        "targets": 3,
                        "orderable": false,
                        "className": "text-center",
                        "createdCell": function (td, cellData, rowData, row, col) {
                            //$(td).html(rowData.work);
                            var html = '<div class="btn-group" role="group"><button class="btn-small btn-outline btn-primary dropdown-toggle" type="button"  data-toggle="dropdown">Order - Worksheet </button><ul class="dropdown-menu"><li class="ms-hover"><a href="/adv/' + rowData.advertiser.slug + '/cam/' + rowData.campaign.slug + '/orders"> Go to Order</a> </li><li class="ms-hover"><a href="#" onclick="returnWorksheet(' + rowData.id + ',' + rowData.vendor.id + ')"> Go to Worksheet</a> </li></ul></div>'
                            $(td).html(html);
                        }
                    },
                    {
                        "targets": 2,
                        "orderable": true,
                        "className": "text-center",
                        "createdCell": function (td, cellData, rowData, row, col) {
                            $(td).html('<i class="fa fa-clock-o"></i> ' + moment(cellData).format("MMM. D, YYYY"));
                        }
                    },
                ],
                "createdRow": function (row, data, dataIndex) {
                    $(row).attr('data-order-id', data.id);

                }

            });
        }
        initializeOrdersDashTable(moment().startOf('year').format("YYYY-MM-DD") + "_" + moment().endOf('year').format("YYYY-MM-DD"));
        function returnWorksheet(order_id, vendor_id)
        {
            show_loader();
            $.ajax({
                type: 'GET',
                url: '/adv/return_worksheet/' + order_id +'/' + vendor_id,
                dataType: 'json',
                encode: true,
                success: function (data) {
                    hide_loader();
                    //console.log("redirect new order");
                    console.log(data.redirect);
                    window.location.href= data.redirect;
                },
                error: function (xhr) {
                    debug(xhr.responseText);
                    ajax_error();
                }

            });
        }
    }
    var refreshAdv = true
    var actual_date_range = moment().startOf('year').format("YYYY-MM-DD") + "_" + moment().endOf('year').format("YYYY-MM-DD")

    //ACTION ON DATE RANGE CHANGE ON ANY DASHBOARD BOX
    $(document).on("click", '.card[data-loader="table_advertiser"] .nav-item',function () {
        if(refreshAdv && typeof app_advertisers_table !== "undefined"){
            //$('#app-advertisers-dash-table').DataTable().draw();
            if($(this).children('a').attr("href") == "#home")
                initializeCampaignsDashTable(actual_date_range);
            else
                initializeAdvertisersTable(false, actual_date_range);
            refreshAdv = false
        }
    })

    $( document ).ready(function() {
        top_line_stats("advertiser", "this_year", "advertiser_top", "#00C851")
        top_line_stats("campaign", "this_year", "campaign_top", "#ab8ce4")
        top_line_stats("order", "this_year", "order_top", "#33b5e5")
        top_line_stats("invoice", "this_year", "invoice_top", "#ff4444")
        bottom_line_stats("invoices", "this_year", "invoices_bottom", "#00C851")
        bottom_line_stats("orders", "this_year", "orders_bottom", "#13dafe")
        bottom_line_stats("profits", "this_year", "profits_bottom", "#6164c1")
        moneyRefresh("money", "this_year", "money")
    });
    //moneyRefresh("buy", "this_year", "money")

    //NEW CODE
    $(function() {

        var start = moment().startOf('year');
        var end = moment().endOf('year');

        function cb(start, end) {
            console.log($(this), this)
            if(typeof this.element !== "undefined" && typeof this.element[0] !== "undefined") {
                if(this.chosenLabel == "Custom Range")
                    $(this.element[0]).children("span").html(start.format('MMMM D, YYYY') + ' - ' + end.format('MMMM D, YYYY'));
                else
                    $(this.element[0]).children("span").html(this.chosenLabel);
                var loader = $(this.element[0]).closest("div.card").data("loader")
                if(loader.indexOf("table_") !== -1)
                    tables_refresh(loader.replace("table_",""), this, loader)
                else if(loader.indexOf("money") !== -1){
                    moneyRefresh("money", this, loader)
                    //moneyRefresh("buy", $(this).val(), loader)
                }else if(loader.indexOf("_bottom") !== -1){
                    bottom_line_stats(loader.replace("_bottom",""), this, loader, colors[loader.replace("_bottom","")])
                }else if(loader.indexOf("_top") !== -1)
                    top_line_stats(loader.replace("_top",""), this, loader, colors[loader.replace("_top","")])
            }else
                $(".reportrange").children("span").html("This Year");
        }

        $('.reportrange').daterangepicker({
            startDate: start,
            endDate: end,
            ranges: {
                'This Year': [moment().startOf('year'), moment().endOf("year")],
                'Last Year': [moment().subtract(1, 'year').startOf('year'), moment().subtract(1, 'year').endOf('year')],
                'This Quarter': [moment().startOf('quarter'), moment().endOf('quarter')],
                'Last Quarter': [moment().subtract(1, 'quarter').startOf('quarter'), moment().subtract(1, 'quarter').endOf('quarter')],
                'This Month': [moment().startOf('month'), moment().endOf('month')],
                'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
                'This Week': [moment().startOf('week'), moment().endOf('week')],
                'Last Week': [moment().subtract(1, 'week').startOf('week'), moment().subtract(1, 'week').endOf('week')],
                'Today': [moment(), moment()],
            }
        }, cb);

        cb(start, end);

    });
}
//END GENERAL DASHBOARD
